import _ from "underscore"
import BasePDFDefinitionCreator from "../BasePDFDefinitionCreator";
import DataTableCreateDefinitionHelper from "../leavesReport/DataTableCreateDefinitionHelper";
import PDFImageCache from "../PDFImageCache"
import {REPORT_LOGO_PATH, PaperOrientation} from "../constants"
import {atImgPath, imgPath} from "../../atBrowserUtils"
import messageResource from "../../messageResource"
import * as PDFDefinitionColumnBuilder from "./PDFDefinitionColumnBuilder"
import PDFDefinitionBuilder from "./PDFDefinitionBuilder";
import {ColumnsConfig} from "../../reports/overtimeReport/ColumnsConfig"
import {Feature, isEnabled} from "../../features/index"

export default class PDFDefinitionCreator extends BasePDFDefinitionCreator {
    createDocDefinition(pdfConfig, parameterFormatter, store) {
        this.parameterFormatter = parameterFormatter;
        this.pdfPrintParams = pdfConfig.pdfPrintParameters;
        this.pdfData = pdfConfig.pdfData;
        this.pdfConfig = pdfConfig;
        this.reportParams = pdfConfig.reportParams;
        this.dateFormat = this.pdfConfig.dateFormat;

        var rowSpanNumber = 2;

        var columns = [];
        columns.push(new PDFDefinitionColumnBuilder.Levels().init(this.reportParams, store, rowSpanNumber));

        if (this.reportParams.columnsConfig !== ColumnsConfig.OVERTIME_ONLY) {
            columns.push(new PDFDefinitionColumnBuilder.TimeBalance().init(this.reportParams, rowSpanNumber));
        }

        if (this.reportParams.columnsConfig !== ColumnsConfig.TIME_BALANCE_ONLY) {
            columns.push(new PDFDefinitionColumnBuilder.Overtime().init(this.reportParams, rowSpanNumber));
        }

        var ddb = new PDFDefinitionBuilder();
        ddb.init(this.pdfPrintParams.paperOrientation, this.pdfPrintParams.paperSize, columns, rowSpanNumber, this.reportParams);

        // start create doc definition
        return PDFImageCache
            .preloadImages(this._imagesMap(pdfConfig)) // preload needed images
            .then(
                _.bind(this._processCreateDocDefinition, this, ddb) // construct doc definition
            )
            .then(function() {
                // return object for generate pdf
                return {
                    "docDefinition": ddb.getDocDefinitionObject(),
                    "tableLayouts": ddb.getTableLayouts()
                }
            });
    }

    _imagesMap() {
        return {
            "logo": {
                "url": REPORT_LOGO_PATH
            },
            "filterIcon": {
                "url": atImgPath('filter-for-pdf.png'),
                "saveAlpha": true
            },
            "noteIcon": {
                "url": imgPath('support/note_mark.gif'),
                "saveAlpha": true
            }
        };
    }

    _processCreateDocDefinition(ddb) {
        ddb.initDocDefinitionObject(this.pdfPrintParams.showSignatureOnEachPage && this.pdfPrintParams.showSignature, this.pdfPrintParams.showHeaderOnEachPage);

        var headerData = this._createHeaderData();
        if (this.pdfPrintParams.paperOrientation === PaperOrientation.PORTRAIT) {
            ddb.addPortraitHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData);
        }
        else {
            ddb.addLandscapeHeader(this.pdfPrintParams.showHeaderOnEachPage, this.pdfPrintParams.showLogoInHeader, headerData)
        }

        this._addTableData(ddb);
        if (isEnabled(Feature.OVR) && this.reportParams.columnsConfig !== ColumnsConfig.TIME_BALANCE_ONLY)
            this._addNotes(ddb);
    }

    _createHeaderData() {
        var selectedParameters = this.pdfConfig.reportParams;

        return {
            informationTexts: {
                title: this.parameterFormatter.formatChartPDFReportTitle(selectedParameters),
                dateRange: this.parameterFormatter.formatChartPDFHeaderDateInformation(selectedParameters)
            },
            filterTexts: this.parameterFormatter.formatChartPDFFilterInformation(selectedParameters),
            logo: PDFImageCache.getImage('logo')
        }
    }

    _addTableData(ddb) {
        new DataTableCreateDefinitionHelper(ddb, this.pdfData.tableData, {
            dateFormat: this.dateFormat
        }).createTable();
    }

    _addNotes(ddb) {
        ddb.addNotes(messageResource.getMessage("overtime_report.pdf.overtime_shown_only_for_note"), '*', true);

        var calculationKey = isEnabled(Feature.LVT) ? "overtime_report.pdf.overtime_with_leaves_calculation_note" :
                             "overtime_report.pdf.overtime_calculation_note";

        ddb.addNotes(messageResource.getMessage("report.overtime.auto_calculated_for_user") + '\n' +
                     messageResource.getMessage(calculationKey), '**', false);

        ddb.addIconedNote(messageResource.getMessage("report.overtime.auto_calculated_within_date_range"));
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/overtimeReport/PDFDefinitionCreator.js